import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";
import Modal from 'bootstrap/js/dist/modal';


$(() => {
    adminPanel.init();
});


const adminPanel = {
    $body: null,
    $list: null,
    list: null,
    $modal: null,
    $editForm: null,
    editForm: null,
    $translateWrapper: null,
    $translationForm: null,
    translationForm: null,
    $submitBtn: null,
    $translateBtn: null,
    largestId: null,
    defaults: {
        id: '',
        url: '',
        countryId: '',
        regionId: '',
        placeId: '',
        // contentId: '',
        image: '',
        title: '',
        listPage: null,
        h1: '',
        short_content: '',
        long_content: '',
        meta_title: '',
        meta_description: '',
        meta_keywords: '',
        near_sea: null,
        sea_view: null,
        pool: null,
        pets: null,
    },
    requiredFileds: ['id', 'url', 'countryId'],
    init()
    {
        adminPanel.$body = $('.admin-panel');
        if (! adminPanel.$body[0]) return;

        this.$list = $('.list');
        this.list = this.$list[0];
        
        $('.reimport').on('click', () => {
            adminPanel.setLoadingMode()
            $.get('/excel/parse/').then( response => {
                adminPanel.unsetLoadingMode();
                response = JSON.parse(response);
                if(response.status) alert(response.message);
            })
        })
        
        if(this.list)
        {
            this.$editForm = $('.edit-form');
            this.editForm = this.$editForm[0];

            this.$translateWrapper = $('.translation-wrapper');
            this.$modal = $('.modal-body');

            this.$translationForm = $('.translation-form');
            this.translationForm = this.$translationForm[0];

            this.largestId = $('.largest-id').data('largestid');
            
            $('[data-bs-toggle="tooltip"]').tooltip();
            
            $('.edit').on('click', (e) => {
                this.setFormData(e);
            });            
            
            $('.translate-modal').on('click', (e) => {
                let canonical = $(e.currentTarget).parent().attr('data-canonnical');
                this.$modal.find('option').each((index, elem) => {
                    let $elem = $(elem);
                    $elem.html($elem.attr('data-lang'));
                    if (canonical.includes($elem.val())) $elem.append(' - EXISTS');
                })
            });            
            
            $('.copy').on('click', (e) => {
                this.setListPage(e);
            });  

            $('.delete').on('click', (e) => {
                this.deletePage(e);
            });            

            $('.new').on('click', (e) => {
                this.newDestination();
            });            
            
            $('.edit-save').on('click', () => {
                adminPanel.setLoadingMode();
                let formData = $.extend({}, adminPanel.defaults, functions.getFormData(this.$editForm));
                formData = adminPanel.formatFormData(formData);
                let index = $( "input[name=dataIndex]" ).val();
                let excelData = {
                    index: index,
                    row: formData
                };
                adminPanel.writeDataToExcel(excelData);
            })

            $('.translation-save').on('click', () => {
                adminPanel.setLoadingMode();
                let formData = $.extend({}, adminPanel.defaults, functions.getFormData(adminPanel.$translationForm));
                // In case there is no id this page is treated as NEW PAGE, so it gets autoicremented id
                if (! formData.id)
                {
                    ++this.largestId;
                    formData.id = this.largestId;
                }
                formData = this.formatFormData(formData);
                let excelData = {
                    new: true,
                    row: formData
                };
               adminPanel.writeDataToExcel(excelData, true);
            })

            $('.translate-modal').on('click', (e) => {
                this.setFormData(e);
            });

            $('.close-translation-form').on('click', () => {
                this.closeTranslationForm();
            });
            adminPanel.setTranslateBtn();
            
        }
    },
    setFormData(e)
    {
        var formData = $(e.target).parent().attr('data-row');
        let index = $(e.target).parent().attr('data-index');
        $( "input[name=dataIndex]" ).val(index);
        functions.setFormData(this.editForm, JSON.parse(formData));
        $('.edit-wrapper').css('display', 'block');
        $('.edit-wrapper').css('opacity', '1');
    },
    newDestination()
    {
        // functions.setFormData(this.editForm, JSON.parse(formData));
        this.$translateWrapper.css('display', 'block');
        this.$translateWrapper.css('opacity', '1');
    },
    setListPage(e)
    {
        var formData = $(e.target).parent().attr('data-row');
        let index = $(e.target).parent().attr('data-index');
        $( "input[name=dataIndex]" ).val(index);
        formData = JSON.parse(formData);
        formData.id = null;
        functions.setFormData(this.translationForm, formData);
        this.$translateWrapper.css('display', 'block');
        this.$translateWrapper.css('opacity', '1');
    },
    deletePage(e)
    {
        adminPanel.setLoadingMode();
        var formData = $(e.target).parent().attr('data-row');
        let index = $(e.target).parent().attr('data-index');
        $( "input[name=dataIndex]" ).val(index);
        formData = JSON.parse(formData);
        if(confirm("Are you sure you want to delete: " + formData.url))
        {
            let excelData = {
                delete: true,
                index: index,
                row: formData
            };
           adminPanel.writeDataToExcel(excelData, false, true);
        }
        adminPanel.unsetLoadingMode();

    },
    setTranslateBtn()
    {
        $('.translate-button').on('click', () => {
            let language = $.extend({}, functions.getFormData(adminPanel.$modal));
            let formData = $.extend({}, adminPanel.defaults, functions.getFormData(adminPanel.$editForm));
            let toTranslate = {
                title:              formData.title,
                h1:                 formData.h1,
                meta_title:         formData.meta_title,
                meta_description:   formData.meta_description,
                meta_keywords:      formData.meta_keywords,
                short_content:      formData.short_content,
                long_content:       formData.long_content,
            };
            let body = {
                language: language.language,
                data: toTranslate
            }
            adminPanel.closeModal();
            adminPanel.setLoadingMode();

            $.post('/translate/', body).then( response => {
                adminPanel.unsetLoadingMode();
                response = JSON.parse(response);
                if (response.status)
                {
                    alert(response.message);
                }
                else
                {
                    let newRow = {};
                    Object.keys(toTranslate).forEach( (key, index) => {
                        newRow[key] = response[index];
                    });
                    newRow = $.extend({}, formData, newRow);
    
                    adminPanel.$list.css('display', 'none');
                    functions.setFormData(adminPanel.translationForm, newRow);
                    this.$translateWrapper.css('display', 'block');
                    this.$translateWrapper.css('opacity', '1');
                }
            })
        })
    },

    closeModal()
    {
        var modal = Modal.getInstance($('#exampleModal'));
        modal.hide();
        $('.modal-backdrop').remove();
    },

    setLoadingMode()
    {
        adminPanel.$body.prepend(tplLoader).scrollTop(0);
    },

    unsetLoadingMode()
    {
        adminPanel.$body.find('.list-loader').remove();
    },

    closeTranslationForm()
    {
        this.$translateWrapper.css('display', 'none');
        this.$translateWrapper.css('opacity', '0');
        this.$list.css('display', 'block');
    },

    formatFormData(formData)
    {
        let allowed = Object.keys(adminPanel.defaults);
        Object.keys(formData).forEach( key => {
            if (! allowed.includes(key)) delete formData[key];
        })
        adminPanel.requiredFileds.forEach( key => {
            if (! formData[key]) {
                alert("ID, Url or CountryID are empty");
                adminPanel.unsetLoadingMode();
                throw new Error("Required fileld is empty");
            }
        })
        return Object.assign({}, adminPanel.defaults, formData)
    },
    
    writeDataToExcel(data, translation = false, remove = false)
    {
        data.file = functions.getUrlData().file;
        $.post('/excel/write/', data).then( response => {
            adminPanel.unsetLoadingMode();
            response = JSON.parse(response);
            if(response.status) alert(response.message);
            if(translation)
            {
                this.$translateWrapper.css('display', 'none');
                this.$translateWrapper.css('opacity', '0');
                this.$list.css('display', 'block');
            }
            else if(remove)
            {
                let $target = $("[data-rowindex='" + data.index + "']")
                $target.fadeOut(750, function(){ $(this).remove();});
            }
            else
            {
                let $el = $("[data-index='" + data.index + "']");
                $el.attr('data-row', JSON.stringify(data.row));
            }
            
        })
    }
}